import * as React from "react"

export default class AxeNumberField extends React.Component<Props> {
	static inputName = "axe-number"

	render() {
		return <div className="field">
			<label className="label">Axe analytique</label>

			<span className="field">
				<span className="control">
					<label className="radio">
						<input
						checked={this.props.value === 1}
						disabled={this.props.loading}
						name={AxeNumberField.inputName}
						type="radio"
						value={1}
						onChange={() => this.props.onChange(1)}/>
						&nbsp;Axe 1
					</label>
					<label className="radio">
						<input
						checked={this.props.value === 2}
						disabled={this.props.loading}
						name={AxeNumberField.inputName}
						type="radio"
						value={2}
						onChange={() => this.props.onChange(2)}/>
						&nbsp;Axe 2
					</label>
				</span>
			</span>
		</div>
	}
}

interface Props {
	loading: boolean;
	value: 1 | 2;
	onChange(value: 1 | 2): void;
}



// WEBPACK FOOTER //
// ./src/component/page/local-authority-detail-page/connector-field/berger-levrault-connector/axe-number-field.tsx